/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {inProcessJobs} from "../state_managers/ExportsStateManager";
import ErrorRetry from './ErrorRetry';

type Props = {
  allImmediately: Function
  allWhenOptimal: Function
}

type State = {
  initialLoad: boolean
}

// several areas of the app load filbert jobs in the
// exact same way. this standardizes that loading
// approach between them.
export default function withJobsLoad(key: string) {
  return (component: any) =>
    class WithJobsLoad extends Component<Props, State> {
      static displayName = 'withJobsLoad';

      static propTypes = {
        allImmediately: PropTypes.func.isRequired,
      };

      static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps[key].isReady) {
          if (!nextProps[key].isLoading && inProcessJobs(nextProps[key].jobs).length) {
            nextProps.allWhenOptimal();
          }

          if (prevState.initialLoad) {
            return { initialLoad: false };
          }
        }

        return null;
      }

      constructor(props: Props) {
        super(props);
        this.state = { initialLoad: true };
      }

      // Move Redux action dispatch from constructor to componentDidMount
      // to avoid React 19 render phase issues
      componentDidMount() {
        this.props.allImmediately();
      }

      render() {
        // When the jobs load failed (ALL_FAILURE set isError), show an error +
        // retry instead of falling through to the wrapped component, which would
        // render a false empty table ("no requests"). Retry re-runs the load.
        const jobState = this.props[key];
        if (jobState && jobState.isError && !this.state.initialLoad) {
          return React.createElement(ErrorRetry, {
            onRetry: this.props.allImmediately,
          });
        }

        return React.createElement(component, {
          ...this.props,
          isLoading: this.state.initialLoad,
        });
      }
    };
}
